export default "/images/smart_contracts_development/smart_contracts_audit__bug_fixes.png";